import { render, staticRenderFns } from "./goodsCombinationEdit.vue?vue&type=template&id=40e407e0&scoped=true"
import script from "./goodsCombinationEdit.vue?vue&type=script&lang=js"
export * from "./goodsCombinationEdit.vue?vue&type=script&lang=js"
import style0 from "./goodsCombinationEdit.vue?vue&type=style&index=0&id=40e407e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e407e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e407e0')) {
      api.createRecord('40e407e0', component.options)
    } else {
      api.reload('40e407e0', component.options)
    }
    module.hot.accept("./goodsCombinationEdit.vue?vue&type=template&id=40e407e0&scoped=true", function () {
      api.rerender('40e407e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsCombinationEdit.vue"
export default component.exports